import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, cancel } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Scanned = Loadable({
    loader: () => import('./Scanned'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          cashInScannedState: state.cashInScannedState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          cancel
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/scanned`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Scanned {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
